export const theme = {
  colors: {
    primary: '#1D9DE7', // 青（背景.svgのメインカラー）
    secondary: '#34C247', // 緑（背景.svgのサブカラー）
    accent: '#FF6347', // トマト
    background: '#F5F5F5', // ライトグレー
    lightBg: '#F8F8F8', // 薄いグレー
    text: '#333333', // ダークグレー
    lightText: '#666666', // ミディアムグレー
    white: '#FFFFFF',
    black: '#000000',
    border: '#DDDDDD',
    success: '#4CAF50', // グリーン
    error: '#F44336', // レッド
    warning: '#FFC107', // イエロー
    info: '#2196F3', // ブルー
    primaryDark: '#1689D2' // プライマリーの暗い色（ホバー時等に使用）
  },
  fonts: {
    body: "'Zen Maru Gothic', sans-serif",
    heading: "'Zen Maru Gothic', sans-serif"
  },
  fontSizes: {
    xs: '0.75rem', // 12px
    sm: '0.875rem', // 14px
    md: '1rem', // 16px
    lg: '1.125rem', // 18px
    xl: '1.25rem', // 20px
    xll: '1.375rem', // 22px
    '2xl': '1.5rem', // 24px
    '3xl': '1.875rem', // 30px
    '4xl': '2.25rem', // 36px
    '5xl': '3rem' // 48px
  },
  fontWeights: {
    normal: 400,
    medium: 500,
    bold: 700
  },
  lineHeights: {
    normal: 1.5,
    none: 1,
    tight: 1.25,
    loose: 2
  },
  space: {
    xs: '0.25rem', // 4px
    sm: '0.5rem', // 8px
    md: '1rem', // 16px
    lg: '3rem', // 48px
    xl: '2rem', // 32px
    '2xl': '4rem', // 64px
    '3xl': '8rem' // 128px
  },
  breakpoints: {
    mobile: '576px',
    tablet: '768px',
    desktop: '992px',
    largeDesktop: '1200px'
  },
  shadows: {
    sm: '0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24)',
    md: '0 3px 6px rgba(0, 0, 0, 0.15), 0 2px 4px rgba(0, 0, 0, 0.12)',
    lg: '0 10px 20px rgba(0, 0, 0, 0.15), 0 3px 6px rgba(0, 0, 0, 0.10)',
    xl: '0 15px 25px rgba(0, 0, 0, 0.15), 0 5px 10px rgba(0, 0, 0, 0.05)'
  },
  radii: {
    none: '0',
    sm: '0.125rem', // 2px
    md: '0.25rem', // 4px
    lg: '0.5rem', // 8px
    xl: '1rem', // 16px
    full: '9999px'
  },
  transitions: {
    default: 'all 0.3s ease',
    fast: 'all 0.15s ease',
    slow: 'all 0.5s ease'
  }
} as const; 